import * as React from "react";
import { Input, Col, Form, Checkbox, Row } from "antd";

import { IStore } from "../../../core/model/runtime/state/Store";
import TranslationInputField from "../../../core/ui/components/TranslationInputField";
import { TOrganisationIndexCategoryPresentationModel } from "../../presenter/model/OrganisationIndexCategoryPresentationModel";

const FormFields = {
  ID: "id",
  NAME: "name",
  INDEX_TYPE_CATEGORY_ID: "indexTypeCategoryId",
  ORGANISATION_ID: "organisationId",
  VALID: "valid"
};
const getInitialValues = (rowData, store: IStore) => {
  if (rowData && Object.keys(rowData).length > 0) {
    if (rowData.nameTranslations.length > 0) {
      return rowData.nameTranslations;
    } else {
      return [
        {
          nameTranslation: rowData.name,
          languageId: store.getState<any>().selectedLanguage.id,
          valid: true
        }
      ];
    }
  } else {
    return [
      {
        nameTranslation: "",
        languageId: store.getState<any>().selectedLanguage.id,
        valid: true
      }
    ];
  }
};
const OrganisationIndexCategoryForm = ({
  translate,
  form,
  rowData,
  indexTypeCategoryId,
  organisationId,
  store
}: {
  translate: any;
  form;
  rowData?: TOrganisationIndexCategoryPresentationModel;
  indexTypeCategoryId: number;
  organisationId;
  store: IStore;
}) => {
  form.setFieldsValue({
    nameTranslations: getInitialValues(rowData, store)
  });

  return (
    <Form
      layout={"vertical"}
      form={form}
      initialValues={{ nameTranslations: getInitialValues(rowData, store) }}
    >
      <Form.Item
        name={FormFields.ID}
        initialValue={rowData?.id}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FormFields.INDEX_TYPE_CATEGORY_ID}
        initialValue={rowData?.indexTypeCategoryId ?? indexTypeCategoryId}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FormFields.ORGANISATION_ID}
        initialValue={rowData?.organisationId ?? organisationId}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Row gutter={16} className={"content-section-modal-borderless pt-0"}>
        <Col lg={24} sm={24} xs={24} className={"mb-0"}>
          <TranslationInputField
            translate={translate}
            organisationId={organisationId}
            translationObjectIdFieldName={"organisationIndexCategoryId"}
            store={store}
            form={form}
          />
        </Col>
      </Row>
      <Col
        lg={2}
        sm={3}
        xs={4}
        style={{
          display: "flex",
          marginTop: 20,
          alignItems: "center"
        }}
      >
        <Form.Item
          label={translate("editors.organisations.valid")}
          className={"png-form-item-horizontal-checkbox mb-0"}
          name={FormFields.VALID}
          valuePropName={"checked"}
          initialValue={rowData?.valid ?? true}
        >
          <Checkbox />
        </Form.Item>
      </Col>
    </Form>
  );
};

export default OrganisationIndexCategoryForm;
